import { render, staticRenderFns } from "./VisualizarDadoModal.vue?vue&type=template&id=bb48e7c8&scoped=true"
import script from "./VisualizarDadoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualizarDadoModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VisualizarDadoModal.vue?vue&type=style&index=0&id=bb48e7c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb48e7c8",
  null
  
)

export default component.exports